export const isNumber = (value: unknown) => {
  try {
    return !isNaN(Number(value));
  } catch (err) {
    return false;
  }
};
